export default "__VITE_ASSET__DvWdn7bq__"